import React from 'react'

const ExcelDollarIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24.929}
      height={23.601}
      {...props}
    >
      <defs>
        <radialGradient
          id="a"
          cx={6.02}
          cy={25.157}
          r={0.39}
          gradientTransform="matrix(1.661 0 0 1.921 -3.837 -22.366)"
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#237f4c" />
          <stop offset={1} stopColor="#1e6c41" />
        </radialGradient>
      </defs>
      <g data-name="Group 2621">
        <g>
          <rect
            width={23.35}
            height={18.313}
            fill="#fff"
            rx={3.375}
            transform="translate(1.23 2.582)"
          />
          <path
            fill="#1f7144"
            d="M13.588 16.641h3.983v2.046h-3.983Zm4.8 0h3.983v2.042h-3.983Zm-4.8-2.966h3.983v2.144h-3.983Zm4.8 0h3.983v2.144h-3.983Zm-4.8-2.961h3.983v2.144h-3.983Zm4.8 0h3.983v2.144h-3.983Zm-4.8-2.961h3.983v2.142h-3.983Zm4.8 0h3.983v2.142h-3.983Zm-4.8-2.961h3.983v2.144h-3.983Zm4.8 0h3.983v2.144h-3.983ZM13.45 2.345v.813h10.658V20.42H13.449v.817h10.59a.889.889 0 0 0 .889-.889V3.233a.889.889 0 0 0-.889-.889h-10.59Z"
          />
          <path
            fill="url(#a)"
            d="M18.68 9.063 4.469 11.59V30.1l14.2 2.566Zm-7.62 11.8Z"
            transform="translate(-4.469 -9.063)"
          />
        </g>
        <text
          fill="#fff"
          data-name="$"
          fontFamily="HelveticaNeue-Medium, Helvetica Neue"
          fontSize={12}
          fontWeight={500}
          transform="translate(3.192 15.89)"
        >
          <tspan x={0} y={0}>
            {"$"}
          </tspan>
        </text>
      </g>
    </svg>
  )
}

export default ExcelDollarIcon
